export default [
  {
    path: '/navigationGroups/:id?',
    name: 'navigationGroups#show',
    component: () => import('@views/navigationGroups/show'),
    meta: {
      header: true,
    },
  },
];
